export class ListAzureUnassignedNetworkInterfaces200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkInterfaces",
            "baseName": "networkInterfaces",
            "type": "Array<ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureUnassignedNetworkInterfaces200Response.attributeTypeMap;
    }
    constructor() {
    }
}
